<template>
  <div class="relative">
    <img
      src="@/assets/images/line/Vector 28.png"
      alt="lineimg"
      class="m-auto h-400px"
    />
    <div
      class="lg:flex md:flex justify-center card-mid-chip sm-mt-2neg lg:ml-12 md:ml-12 ml-16 lg:pt-0 md:pt-0"
    >
      <div
        class="borderprimary bg-white lg:p-4 md:p-4 mob-pt-3 absolute lg:top-32 md:top-32 top-8 rounded-2xl lg:w-auto md:w-auto w-3/5 m-auto"
      >
        <div class="bgcceff2 rounded-2xl">
          <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
            <p class="font-semibold text-black fsize20 sm-fsize14">
              Join our community
            </p>
            <div
              class="md:pl-12 lg:pl-14 pl-0 items-center flex lg:mx-auto md:mx-auto mob-justify-center"
            >
              <base-button
                type="primary"
                class="py-2 px-8 lg:text-base md:text-base text-xs font-bold border-2 mt-2 md:mt-0 lg:mt-0 whitespacenowrap mx-auto md:w-auto lg:w-auto w-full"
                @click="handleClick('product-services')"
                >Our Services
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style></style>
